import { formatDateToLocalISO } from "@repo/ui-parkmobile/utils/dateTime";
import { OUTBOUND_UTM_SOURCE } from "@repo/ui-parkmobile/utils/url";

export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/,/g, "")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .trim();
};

export const createParkingSearchUrl = (
  destination: string,
  options?: {
    coordinates?: { lat: number; lng: number };
    zoom?: number;
    startDate?: Date | null;
    endDate?: Date | null;
    filterType?: string[];
  },
): string => {
  const {
    coordinates,
    zoom = 16,
    startDate,
    endDate,
    filterType,
  } = options || {};

  let baseUrl: string;

  if (coordinates) {
    baseUrl = `https://app.parkmobile.io/search/?latitude=${coordinates.lat}&longitude=${coordinates.lng}&zoom=${zoom}`;
  } else {
    baseUrl = `https://app.parkmobile.io/search/${slugify(destination)}`;
  }

  const params = new URLSearchParams();

  if (startDate) {
    params.set("startDate", formatDateToLocalISO(startDate));
  }
  if (endDate) {
    params.set("endDate", formatDateToLocalISO(endDate));
  }
  if (filterType && filterType.length > 0) {
    params.set("filters", filterType.join(","));
  }
  params.set("utm_source", OUTBOUND_UTM_SOURCE);

  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${params.toString()}`;
};
